export default "/assets/images/mila-filters-boxes.webp?1183d65d0da1487eadf634bdbfcbe5ac";